import React, { useEffect, useState } from "react";
import { Card, Row, Col, Collapse, Tag, Avatar, Spin, Space } from "antd";
import { DownCircleOutlined, LoadingOutlined, RightCircleOutlined, UserOutlined } from "@ant-design/icons";
import { DashboardService } from "./services/dashboard-service";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";
import { useId24 } from "../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../config/app-config";
import { numberWithCommas } from "../../utils";
const appConfig = loadAppConfig();
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;

interface Props {
  baseUrl: string;
}
const frontStyleCard = {
  textAlign: "left",
  fontSize: "12px",
} as any;

const fontStyleHerder = {
  fontSize: "18px",
  color: "#FFFFFF",
} as any;

const fontStyleTap = {
  fontSize: "14px",
  borderRadius: "10px",
} as any;

const frontStyleInCard = {
  textAlign: "left",
  fontSize: "10px",
} as any;

const statusConfig: any = {
  new: {
    label: "New",
    cardBg: "#0056B4",
    tagColor: "#1890FF",
    textColor: "#108ee9",
    avatarBg: "#E1EDF9",
    iconColor: "#035BBD",
  },
  action: {
    label: "Action",
    cardBg: "#70C787",
    tagColor: "#52C41A",
    textColor: "#52C41A",
    avatarBg: "#DEFFCD",
    iconColor: "#52C41A",
  },
  noAction: {
    label: "No-Action",
    cardBg: "#EE5F77",
    tagColor: "#FF4D4F",
    textColor: "#FF4D4F",
    avatarBg: "#FFE2E2",
    iconColor: "#FF4D4F",
  },
};

export const DashboardManager: React.FC<Props> = ({ baseUrl }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const history = useHistory();
  const { id24Axios } = useId24();

  const [dataSource, setDataSource] = useState<{
    new: any[];
    action: any[];
    noAction: any[];
  }>({
    new: [],
    action: [],
    noAction: [],
  });

  function integrateDashboard(data: any[], status: "new" | "action" | "noAction") {
    let listNew: any[] = [];
    let collList: any[] = [];
    let dataSource: any[] = [];

    data.forEach((x1: any) => {
      console.log(x1);

      if (x1.actionstatus === status) {
        listNew.push({
          listname: x1.listname,
          collid: x1.collid,
          collname: x1.collname,
          cnt: x1.cnt,
          sumamt: x1.sumamt,
          sumcurbal: x1.sumcurbal,
          sumos: x1.sumos,
          sumstmtamt: x1.sumstmtamt,
          supname: x1.supname,
          manid: x1.manid,
        });

        collList.push({ supname: x1.supname, supid: x1.supid, collid: x1.collid, collname: x1.collname, listname: x1.listname });
      }
    });

    const groupByList = listNew.reduce((group: any[], item: any) => {
      const { collid, collname, listname } = item;
      const found = group.find((g) => g.collid === collid && g.listname === listname);

      if (found) {
        found.userlist.push(item);
      } else {
        group.push({
          collid,
          collname,
          listname,
          userlist: [item],
        });
      }

      return group;
    }, []);

    const groupByCollector = (collList: any[]) =>
      Object.values(
        collList.reduce((data: any, { collid, collname, listname }: any) => {
          if (!data[collid]) {
            data[collid] = {
              collid,
              collname,
              ac: 0,
              os: 0,
              bal: 0,
              cur: 0,
              stmt: 0,
              listList: [],
            };
          }

          if (!data[collid].listList.find((l: any) => l.listname === listname)) {
            const userlist = groupByList.find((l) => l.listname === listname && l.collid === collid);
            let ac = 0,
              os = 0,
              bal = 0,
              cur = 0,
              stmt = 0;

            userlist.userlist.forEach((item: any) => {
              ac += item.cnt;
              os += item.sumos;
              bal += item.sumamt;
              cur += item.sumcurbal;
              stmt += item.sumstmtamt;
            });

            data[collid].listList.push({
              listname,
              collname,
              cnt: ac,
              sumamt: bal,
              sumcurbal: cur,
              sumstmtamt: stmt,
              sumos: os,
            });

            data[collid].ac += ac;
            data[collid].os += os;
            data[collid].bal += bal;
            data[collid].cur += cur;
            data[collid].stmt += stmt;
          }

          return data;
        }, {}),
      );

    const result = {
      statusName: status,
      collList: groupByCollector(collList),
    };

    dataSource.push(result);
    return dataSource;
  }

  const toDebt = (status: string, supName: string, supId: string, list: string, collId: string, collName: string) => {
    if (status) {
      let all = {
        type: "SUPOA",
        statusName: status,
        supName: "",
        supId: "",
        listName: list,
        collName: collName,
        collId: collId,
      };
      history.push("/debtmanagement", all);
    }
  };

  useEffect(() => {
    async function fetchDataForSearch() {
      const apiCaller = id24Axios(appConfig.apiBaseUrlDebt);
      const res: any = await DashboardService(apiCaller).getOaManager();
      let conDataNew: any = integrateDashboard(res.result, "new");
      let conDataAction: any = integrateDashboard(res.result, "action");
      let conDataNoAction: any = integrateDashboard(res.result, "noAction");
      setDataSource({
        new: conDataNew,
        action: conDataAction,
        noAction: conDataNoAction,
      });
      setLoading(false);
    }

    if (loading) fetchDataForSearch();
  }, [loading]);

  const renderStatusBlock = (status: "new" | "action" | "noAction") => {
    const conf = statusConfig[status];
    const statusData = dataSource[status];
    if (!statusData || statusData.length === 0) return null;

    return statusData.map((newstatus: any, index: number) => (
      <Col span={8} key={status + index}>
        <Row>
          <Col span={24}>
            {/* HEADER CARD */}
            <Card
              style={{
                backgroundColor: conf.cardBg,
                borderRadius: "5px",
                marginBottom: "10px",
                justifyContent: "center",
                display: "flex",
                gap: "24px",
              }}
            >
              <Space>
                <b style={fontStyleHerder}>{conf.label}</b>
                <Tag style={fontStyleTap} color={conf.tagColor}>
                  <NumberFormat value={newstatus.collList.length} displayType="text" thousandSeparator />
                </Tag>
              </Space>
            </Card>
            {newstatus.collList.map((collector: any, indexTeam: number) => {
              return (
                <Col key={indexTeam}>
                  <Collapse expandIconPosition="end" bordered={false} ghost style={{ borderRadius: "5px", backgroundColor: "#fff" }}>
                    <Panel
                      key="1"
                      header={
                        <Col span={24}>
                          <Row gutter={[0, 24]}>
                            <Col span={4}></Col>
                            <Col span={18}>
                              <a
                                onClick={() => toDebt(status, "", "", "", collector.collid, collector.collname)}
                                style={{ fontSize: "18px", color: conf.textColor, marginRight: "5px" }}
                              >
                                <b>{collector.collname}</b>
                              </a>
                              <Tag style={{ fontSize: "16px", borderRadius: "10px" }} color={conf.tagColor}>
                                <NumberFormat value={collector.listList.length} displayType="text" thousandSeparator />
                              </Tag>
                            </Col>
                          </Row>

                          <Row>
                            <Col span={4}>
                              <Avatar
                                style={{ backgroundColor: conf.avatarBg }}
                                shape="square"
                                icon={<UserOutlined style={{ color: conf.iconColor }} />}
                              />
                            </Col>
                            <Col span={20} style={{ fontSize: "12px" }}>
                              <div>
                                {`A/C`} <b style={{ color: "black", marginLeft: "2px" }}>{collector.ac}</b>
                              </div>
                              <div>
                                {`BAL`} <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(collector.bal)}</b>
                              </div>
                              <div>
                                {`OS`} <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(collector.os)}</b>
                              </div>
                              <div>
                                {`CUR`} <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(collector.cur)}</b>
                              </div>
                              <div>
                                {`STMT`} <b style={{ color: "black", marginLeft: "2px" }}>{numberWithCommas(collector.stmt)}</b>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      }
                    >
                      {/* <Collapse defaultActiveKey={["0"]}>
                        {collector.listList.map((list: any, indexList: number) => (
                          <Panel
                            key={indexList}
                            header={
                              <>
                                <Col span={8} style={{ fontSize: "12px" }}>
                                  <a
                                    style={{ color: "black" }}
                                    onClick={() => toDebt(status, "", "", list.listname, collector.collid, collector.collname)}
                                  >
                                    {list.listname}
                                  </a>
                                </Col>

                                <Col span={8} style={{ fontSize: "10px" }}>
                                  {`A/C`} <b>{list.cnt}</b>
                                </Col>
                                <Col span={8} style={{ fontSize: "10px" }}>
                                  {`BAL`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumamt)}</b>
                                </Col>
                                <Col span={8} style={{ fontSize: "10px" }}>
                                  {`OS`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumos)}</b>
                                </Col>
                                <Col span={8} style={{ fontSize: "10px" }}>
                                  {`CUR`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumcurbal)}</b>
                                </Col>
                                <Col span={8} style={{ fontSize: "10px" }}>
                                  {`STMT`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumstmtamt)}</b>
                                </Col>
                              </>
                            }
                          />
                        ))}
                      </Collapse> */}
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {collector.listList.map((list: any, indexList: number) => (
                          <Card
                            key={indexList}
                            size="small"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #f0f0f0",
                              backgroundColor: "#fafafa",
                            }}
                            bodyStyle={{ padding: "8px 12px" }}
                          >
                            {/* List name */}
                            <div style={{ marginBottom: "6px" }}>
                              <a
                                style={{ fontSize: "12px", color: "black", fontWeight: "bold" }}
                                onClick={() => toDebt(status, "", "", list.listname, collector.collid, collector.collname)}
                              >
                                {list.listname}
                              </a>
                            </div>

                            {/* Stats */}
                            <Row gutter={[0, 2]}>
                              <Col span={12} style={{ fontSize: "10px" }}>
                                {`A/C`} <b>{list.cnt}</b>
                              </Col>
                              <Col span={12} style={{ fontSize: "10px" }}>
                                {`BAL`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumamt)}</b>
                              </Col>
                              <Col span={12} style={{ fontSize: "10px" }}>
                                {`OS`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumos)}</b>
                              </Col>
                              <Col span={12} style={{ fontSize: "10px" }}>
                                {`CUR`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumcurbal)}</b>
                              </Col>
                              <Col span={24} style={{ fontSize: "10px" }}>
                                {`STMT`} <b style={{ color: "#0056b4" }}>{numberWithCommas(list.sumstmtamt)}</b>
                              </Col>
                            </Row>
                          </Card>
                        ))}
                      </div>
                    </Panel>
                  </Collapse>
                  <br />
                </Col>
              );
            })}
          </Col>
        </Row>
      </Col>
    ));
  };

  return loading ? (
    <>
      <div style={{ justifyContent: "center", display: "flex", alignItems: "center", minHeight: "30vh" }}>
        <Spin spinning={loading} tip="Loading" indicator={antIcon} />
      </div>
    </>
  ) : (
    <>
      <Row
        gutter={[
          { xs: 8, sm: 18 },
          { xs: 8, sm: 18 },
        ]}
      >
        {renderStatusBlock("new")}
        {renderStatusBlock("action")}
        {renderStatusBlock("noAction")}
      </Row>
    </>
  );
};
